import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth, useIsAdmin, useVeEquipa } from '@/features/auth/AuthContext';
import { HojePage } from '@/pages/HojePage';
import { MapaPage } from '@/pages/MapaPage';
import { ObrasPage } from '@/pages/ObrasPage';
import { EquipaPage } from '@/pages/EquipaPage';
import { PerfilPage } from '@/pages/PerfilPage';
import { UtilizadoresPage } from '@/pages/UtilizadoresPage';
import { DefinicoesPage } from '@/pages/DefinicoesPage';
import { LoginPage } from '@/pages/LoginPage';
import { MustChangePage } from '@/pages/MustChangePage';
import { Spinner } from '@/components/ui/Spinner';

export default function App() {
  const { user, loading } = useAuth();
  const veEquipa = useVeEquipa();
  const isAdmin = useIsAdmin();

  if (loading) {
    return (
      <div className="grid min-h-dvh place-items-center bg-conduril">
        <Spinner className="border-white/30 border-t-white" />
      </div>
    );
  }

  if (!user) return <LoginPage />;
  if (user.mustChangePassword) return <MustChangePage />;

  return (
    <Routes>
      <Route path="/hoje" element={<HojePage />} />
      <Route path="/mapa" element={<MapaPage />} />
      <Route path="/obras" element={<ObrasPage />} />
      <Route path="/perfil" element={<PerfilPage />} />
      {veEquipa && <Route path="/equipa" element={<EquipaPage />} />}
      {isAdmin && <Route path="/utilizadores" element={<UtilizadoresPage />} />}
      {isAdmin && <Route path="/definicoes" element={<DefinicoesPage />} />}
      <Route path="*" element={<Navigate to="/hoje" replace />} />
    </Routes>
  );
}
